// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"170":"798362c9","190":"3cff3ecc","216":"d6f21d54","389":"513d40a6","437":"73e90b2a","479":"8b708c92","883":"29fbcc30"}[chunkId] + ".chunk.js";
};